/* eslint-disable no-console */
import React, {useState} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
// import Spinner from 'layout/common/Spinner'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {KTSVG, Model} from 'helpers'
import {TextField} from 'helpers/ui-components/form/TextField'
import {IItmesConfig} from 'models/GenericForm'
import {IFormData, IFormField} from 'models/Common'
// import {toast} from 'react-toastify'
import OnBoardingFormComponent from './OnBoardingFormComponent'

type IProps = {
 userId: string
 parentItemConfig?: IItmesConfig
 loader: boolean
 accessDetails: IFormField
 setLoader: (newState: boolean) => void
 reloadTabs: () => void
}

const AccountSettings = (props: IProps) => {
 const {t} = useTranslation()
 const [isDisabled, setIsDisabled] = useState(true)
 const [deactivateModel, setDeactivateModel] =
  useState(false)
 const [deactivatedMsgModel, setDeactivatedMsgModel] =
  useState(false)
 const [progress, setProgress] = useState(0)
 const disabledDeActivateBtn = true

 const toggleBtnIconList = {
  whatsapp_notif_enabled: '/media/icons/whatsApp.svg',
  email_notif_enabled: '/media/icons/gmail.svg',
  sms_notif_enabled: '/media/icons/message.svg',
 }
 const otpForm = {
  verificationCode: '',
  emailId: '',
  confirmBtn: '',
 }
 const {
  register,
  handleSubmit,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...otpForm},
 })

 const optionList = [
  {
   label: 'Reason 1',
   value: '1',
  },
  {
   label: 'Reason 2',
   value: '2',
  },
  {
   label: 'Reason 3',
   value: '3',
  },
 ]
 const handleProceedBtnClick = () => {
  if (progress === 4) {
   setDeactivatedMsgModel(false)
   setProgress(0)
  } else if (progress === 3) {
   setDeactivateModel(false)
   setDeactivatedMsgModel(true)
   setProgress(progress + 1)
  } else {
   setProgress(progress + 1)
  }
 }

 async function submitOTPFormData(formData: IFormData) {
  console.log('formData', formData)
 }
 return (
  <>
   <Model
    show={deactivateModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     setDeactivateModel(false)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {t(
        'myAccountPage.accountSettings.confirmModelTitle'
       )}
      </p>
      <form
       method='POST'
       action=''
       onSubmit={handleSubmit(submitOTPFormData)}
      >
       <div className='w-full my-7'>
        {optionList.map((val, key) => (
         <div
          key={key}
          className={`${
           key !== optionList.length - 1 &&
           'border-b border-[#E6EBF0]'
          } relative flex items-center p-6 bg-[#F5F8FA] `}
         >
          <div className='text-[#2F2F2F] text-base font-medium ml-1'>
           {val.label}
          </div>
          <div className='ml-auto cursor-pointer'>
           <input
            type='radio'
            className={`w-5 h-5 !border-[#4E83E4]`}
            placeholder=' '
            //  defaultChecked={item[OptionValueKey] === value}
            value={val.value}
            // autoComplete={autoComplete}
            // autoFocus={autoFocus}
            {...register('confirmBtn', {
             validate: {
              required: (v) => {
               if (v === '')
                return `${t('helperText.plsEnter')} ${t(
                 'myAccountPage.personalInformation.panNumber'
                )}`
              },
             },
            })}
           />
          </div>
         </div>
        ))}
        {progress > 0 && (
         <>
          <TextField
           type='text'
           disabled={progress >= 2 ? true : false}
           label={t(
            'myAccountPage.accountSettings.emailId'
           )}
           labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
           className='font-normal'
           wrapperClassName='relative w-full mt-2'
           required={true}
           id='emailId'
           name='emailId'
           placeholder={t('helperText.enterHere')}
           register={register('emailId', {
            validate: {
             required: (v) => {
              if (v === '')
               return `${t('helperText.plsEnter')} ${t(
                'myAccountPage.accountSettings.emailId'
               )}`
             },
             regex: (v) => {
              if (
               v !== '' &&
               !v
                ?.toLowerCase()
                .match(
                 /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )
              )
               return `${t('helperText.plsEnterValid')} ${t(
                'myAccountPage.accountSettings.emailId'
               )}`
             },
            },
           })}
           errors={errors}
          />
          {progress === 1 && (
           <div className='text-[#80868C] text-base font-normal px-4 py-3'>
            {t(
             'myAccountPage.accountSettings.emailHelperText'
            )}
           </div>
          )}
         </>
        )}
        {progress > 1 && (
         <>
          <TextField
           type='text'
           disabled={progress >= 3 ? true : false}
           label={t(
            'myAccountPage.accountSettings.verificationCode'
           )}
           labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
           className='font-normal'
           wrapperClassName='relative w-full mt-2'
           required={true}
           id='verificationCode'
           name='verificationCode'
           placeholder='_ _ _ _ _ _'
           register={register('verificationCode', {
            validate: {
             required: (v) => {
              if (v === '')
               return `${t('helperText.plsEnter')} ${t(
                'myAccountPage.accountSettings.verificationCode'
               )}`
             },
             regex: (v) => {
              if (
               v !== '' &&
               !v
                ?.toLowerCase()
                .match(
                 /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )
              )
               return `${t('helperText.plsEnterValid')} ${t(
                'myAccountPage.accountSettings.verificationCode'
               )}`
             },
            },
           })}
           errors={errors}
          />
          {progress === 2 && (
           <div className='text-[#80868C] text-base font-normal px-4 py-3'>
            {t(
             'myAccountPage.accountSettings.verificationCodeHelperText'
            )}
           </div>
          )}
         </>
        )}
       </div>
       <div className='md:flex items-center justify-center'>
        <Button
         type={'submit'}
         onClick={handleProceedBtnClick}
         color='red'
         className='text-center w-full py-[9px] px-[24px] bg-[#CC293F] 
                        !rounded-lg !text-sm text-white font-semibold'
        >
         {progress === 0
          ? t('myAccountPage.accountSettings.proceed')
          : progress === 1
          ? t(
             'myAccountPage.accountSettings.sendVerificationCode'
            )
          : progress === 2
          ? t('myAccountPage.accountSettings.verifyCode')
          : t(
             'myAccountPage.accountSettings.deactivateAccount'
            )}
        </Button>
       </div>
      </form>
     </div>
    </div>
   </Model>
   <Model
    show={deactivatedMsgModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 bg-[#E6EBF0] rounded-3xl w-7 h-7 hidden'
    header={''}
    close={() => {
     setDeactivatedMsgModel(false)
    }}
    modelClass='md:w-[354px]'
    modelContainerClass='!rounded-lg px-6 py-10'
    modelBodyClass=''
   >
    <div className='w-full'>
     <div className='w-full text-center items-center'>
      <div className='flex justify-center items-center mt-7'>
       <KTSVG
        className={'w-[60px] h-[60px]'}
        path='/media/icons/check.svg'
       />
      </div>

      <p className='text-[#CC293F] font-bold text-2xl mt-7'>
       {t(
        'myAccountPage.accountSettings.accountDeactivated'
       )}
      </p>
      <p className='text-[#000000] font-medium text-base mt-3'>
       {t(
        'myAccountPage.accountSettings.accountDeactivationSuccessMsg'
       )}
      </p>
      <div className='md:flex items-center justify-center mt-7'>
       <Button
        onClick={handleProceedBtnClick}
        color='red'
        className='!w-[160px] text-center w-full py-[9px] px-[24px] bg-[#CC293F] 
                        !rounded-[24px] !text-xl text-white font-bold'
       >
        {t(
         'myAccountPage.accountSettings.accountDeactivationSuccessBtn'
        )}
       </Button>
      </div>
     </div>
    </div>
   </Model>
   <div className='w-full'>
    {isDisabled && (
     <div className='w-full mb-3 justify-end flex'>
      <div className='flex items-center '>
       <Button
        disabled={
         !props.accessDetails?.basicDetails?.canEdit
        }
        onClick={() => {
         if (props.accessDetails?.basicDetails?.canEdit) {
          setIsDisabled(false)
         }
        }}
        color='blue'
        className='text-center py-[9px] pr-6 pl-4 bg-white 
                           !rounded-lg text-base !text-[#4E83E4] font-semibold border-[#4E83E4]'
       >
        <KTSVG
         path={`/media/icons/pencil.svg`}
         svgClassName={`w-4 h-4 text-white p-[2px]`}
        />
        {t('myAccountPage.edit')}
       </Button>
      </div>
     </div>
    )}
    <OnBoardingFormComponent
     userId={props.userId}
     parentItemConfig={props.parentItemConfig}
     loader={props.loader}
     reloadTabs={props.reloadTabs}
     setIsDisabled={setIsDisabled}
     isDisabled={isDisabled}
     setLoader={props.setLoader}
     toggleBtnIconList={toggleBtnIconList}
     className='grid md:grid-cols-1 gap-2 w-full mt-4'
     formBuilderClassName='!w-[350px] mt-5'
    />

    {!disabledDeActivateBtn && (
     <div className='w-full mt-10'>
      <div className='text-[#2F2F2F] text-2xl font-medium'>
       {t(
        'myAccountPage.accountSettings.deactivateAccount'
       )}
      </div>
      <div className='text-[#33393D] text-base font-medium my-4'>
       {t('myAccountPage.accountSettings.confirm')}
      </div>

      <div className='flex items-center '>
       <Button
        disabled={false}
        onClick={() => {
         setDeactivateModel(true)
        }}
        color='blue'
        className='text-center p-3 bg-[#CC293F] 
                  !rounded-lg text-sm text-white font-semibold border-[#E6EBF0]'
       >
        {t(
         'myAccountPage.accountSettings.deactivateBtnLabel'
        )}
       </Button>
      </div>
     </div>
    )}
   </div>
  </>
 )
}

export default AccountSettings
